export interface ArticleData {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  image: string;
  date: string;
  category: string;
  game: string;
  views: number;
  slug: string;
  author: string;
  tags: string[];
}

export const articles: ArticleData[] = [
  {
    id: 1,
    title: 'LPL夏季赛决赛前瞻：BLG与JDG的巅峰对决',
    excerpt: '经过数月的激烈角逐，BLG和JDG两支顶级战队终于将在夏季赛总决赛中相遇。本文详细分析两队近期状态与战术风格。',
    content: `<p>经过数月的激烈角逐，2026年LPL夏季赛终于迎来了最令人期待的总决赛——BLG对阵JDG。这不仅是两支顶级战队的碰撞，更是两种不同战术理念的交锋。</p>
    <h2>BLG：攻势如潮的年轻力量</h2>
    <p>BLG在本赛季展现出了令人惊叹的进攻能力。他们的比赛节奏极快，前期gank成功率高达68%，位列联赛第一。打野选手Xun的状态尤其火热，他的盲僧和李青在季后赛中的表现堪称教科书级别。</p>
    <p>中路knight的发挥同样稳定，他在与JDG的交手记录中保持着不俗的胜率。下路双人组Elk和ON的默契配合也是BLG能够走到决赛的关键因素。</p>
    <h2>JDG：稳如磐石的战术堡垒</h2>
    <p>与BLG的激进风格形成鲜明对比，JDG的打法更加稳健。他们擅长通过资源控制来逐渐扩大优势，场均经济领先达到3500+。Kanavi的野区控制能力依然是世界顶级水平。</p>
    <p>Ruler和Missing的下路组合在本赛季展现了极强的对线压制力，他们的2v2击杀参与率高达75%。</p>
    <h2>决赛看点</h2>
    <p>这场决赛的最大看点在于节奏之争：BLG希望将比赛带入快节奏的混战，而JDG则试图通过稳健运营来控制比赛走向。谁能将自己的节奏强加给对方，谁就将捧起夏季赛冠军奖杯。</p>`,
    image: 'https://readdy.ai/api/search-image?query=professional%20League%20of%20Legends%20esports%20match%20with%20two%20teams%20facing%20off%20on%20stage%2C%20dramatic%20lighting%2C%20Chinese%20esports%20arena%20atmosphere%2C%20editorial%20sports%20photography&width=800&height=500&seq=news-lpl-01&orientation=landscape',
    date: '2026.08.08',
    category: '赛事前瞻',
    game: '英雄联盟',
    views: 12500,
    slug: 'lpl-summer-final-preview',
    author: '电竞观察员',
    tags: ['LPL', '英雄联盟', 'BLG', 'JDG', '总决赛'],
  },
  {
    id: 2,
    title: 'CS2新赛季排名更新：FaZe重回世界第一',
    excerpt: 'HLTV最新世界排名出炉，FaZe Clan凭借近期连续夺冠的强势表现，成功超越NAVI登顶世界第一。',
    content: `<p>HLTV发布了2026年8月最新CS2世界排名，FaZe Clan凭借在IEM科隆站和BLAST春季赛的连续夺冠，以1000分的满分成绩重返世界第一宝座。</p>
    <h2>FaZe的统治之路</h2>
    <p>在过去的两个月里，FaZe展现了令人窒息的统治力。他们在IEM科隆站中以3-0的完美战绩击败G2夺冠，随后在BLAST春季赛中再次以统治级表现横扫所有对手。</p>
    <p>ropz和broky的个人能力在关键时刻屡次拯救队伍，而karrigan的战术指挥也被认为是当前CS2赛场上最为出色的。</p>
    <h2>排名变化</h2>
    <p>NAVI下滑至第二位，G2稳居第三，Vitality排名第四。值得关注的是，中国战队TYLOO在近期比赛中表现出色，排名上升至第15位。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Counter%20Strike%202%20esports%20team%20celebrating%20championship%20victory%20on%20stage%20with%20trophy%2C%20confetti%20and%20spotlights%2C%20professional%20esports%20photography&width=800&height=500&seq=news-cs2-01&orientation=landscape',
    date: '2026.08.07',
    category: '排名更新',
    game: 'CS2',
    views: 8900,
    slug: 'cs2-ranking-update-faze',
    author: 'FPS观察者',
    tags: ['CS2', 'FaZe', '世界排名', 'HLTV'],
  },
  {
    id: 3,
    title: 'DOTA2 TI13直邀名单确认，中国战队LGD成功入围',
    excerpt: 'V社正式公布了TI13的直邀名单，LGD作为中国赛区代表成功获得直接晋级资格，将在西雅图争夺冠军。',
    content: `<p>Valve正式公布了2026年DOTA2国际邀请赛（TI13）的直邀名单。令人振奋的是，中国战队PSG.LGD成功获得直接晋级资格。</p>
    <h2>直邀名单一览</h2>
    <p>本次获得直邀资格的战队包括：Team Spirit、LGD、OG、Tundra Esports、BetBoom Team等12支全球顶级战队。这些战队在过去一年的DPC赛事中积累了足够的积分。</p>
    <h2>LGD的晋级之路</h2>
    <p>LGD在本赛季的表现可圈可点，他们在多个Major赛事中取得了前四名的好成绩。NothingToSay的中单发挥稳定，而新加入的年轻Carry选手也展现了巨大潜力。</p>
    <h2>TI13展望</h2>
    <p>TI13将于9月在西雅图举行，总奖金池预计将超过3000万美元。中国赛区能否在本届TI上重夺冠军荣耀，让我们拭目以待。</p>`,
    image: 'https://readdy.ai/api/search-image?query=DOTA%202%20esports%20team%20LGD%20on%20stage%20with%20fans%20waving%20flags%2C%20international%20tournament%20atmosphere%2C%20Chinese%20esports%20pride&width=800&height=500&seq=news-dota-01&orientation=landscape',
    date: '2026.08.06',
    category: '赛事新闻',
    game: 'DOTA2',
    views: 15600,
    slug: 'ti13-direct-invite-lgd',
    author: 'DOTA观察站',
    tags: ['DOTA2', 'TI13', 'LGD', '国际邀请赛'],
  },
  {
    id: 4,
    title: 'Valorant新特工正式上线，职业赛场Meta即将大变',
    excerpt: '拳头游戏发布了Valorant最新特工，其独特技能组合预计将对职业赛场的战术体系产生深远影响。',
    content: `<p>拳头游戏在最新的版本更新中正式推出了Valorant的第25位特工。这位来自巴西的先锋型特工拥有独特的区域控制技能，预计将对职业赛场的战术格局产生重大影响。</p>
    <h2>新特工技能解析</h2>
    <p>新特工的标志性技能是在目标区域制造一个持续8秒的声波场，范围内的敌人将受到移动速度减缓和视野干扰。这一技能在防守和进攻中都有极高的战术价值。</p>
    <h2>职业赛场影响</h2>
    <p>多位职业教练和分析师认为，新特工的加入将改变当前以决斗者为核心的Meta体系。特别是在Bind和Split等地图上，新特工的控制能力将提供全新的战术选择。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Valorant%20new%20agent%20reveal%20cinematic%20style%20image%20with%20futuristic%20character%20design%2C%20neon%20colors%2C%20dynamic%20action%20pose&width=800&height=500&seq=news-val-01&orientation=landscape',
    date: '2026.08.05',
    category: '游戏更新',
    game: 'Valorant',
    views: 7200,
    slug: 'valorant-new-agent-meta',
    author: '战术分析师',
    tags: ['Valorant', '新特工', 'Meta', '职业赛场'],
  },
  {
    id: 5,
    title: '王者荣耀世冠赛制改革：双败淘汰制正式引入',
    excerpt: 'KPL官方宣布2026年王者荣耀世界冠军杯将采用全新的双败淘汰赛制，为赛事增加更多悬念和观赏性。',
    content: `<p>KPL官方今日正式宣布，2026年王者荣耀世界冠军杯将进行全面赛制改革，其中最引人注目的变化是正式引入双败淘汰制。</p>
    <h2>改革要点</h2>
    <p>新赛制下，所有参赛战队在淘汰赛阶段将拥有"两条命"——在输掉一场比赛后进入败者组，仍有继续争夺冠军的机会。这一赛制已在DOTA2的TI赛事中证明能够极大提升比赛的观赏性和公平性。</p>
    <h2>各方反应</h2>
    <p>多数职业战队和选手对这一改革表示欢迎，认为双败淘汰制能更好地反映战队的真实实力。赛事观众也将能看到更多高质量的对决。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Honor%20of%20Kings%20esports%20press%20conference%20announcement%20with%20official%20representatives%2C%20Chinese%20esports%20event%20stage%2C%20professional%20photography&width=800&height=500&seq=news-kpl-01&orientation=landscape',
    date: '2026.08.04',
    category: '赛事改革',
    game: '王者荣耀',
    views: 18900,
    slug: 'kpl-world-championship-format-change',
    author: 'KPL特约记者',
    tags: ['王者荣耀', 'KPL', '赛制改革', '双败淘汰'],
  },
  {
    id: 6,
    title: 'PUBG电竞生态持续扩张，全球合作伙伴计划公布',
    excerpt: 'Krafton公布了2026年PUBG电竞全球合作伙伴名单，包括来自全球各大赛区的12支顶级战队。',
    content: `<p>Krafton在首尔举行了2026年PUBG电竞全球合作伙伴计划发布会，正式公布了新一届合作战队名单。</p>
    <h2>合作战队名单</h2>
    <p>本次入选的12支战队来自全球四大主要赛区，包括中国的17Gaming、韩国的Gen.G、欧洲的TWIS等顶级战队。这些战队将获得赛事直邀资格和额外的资源支持。</p>
    <h2>生态扩展</h2>
    <p>Krafton同时宣布将在2026年增加PGS系列赛的举办频率，从每年4次增加到6次，为全球PUBG电竞生态注入更多活力。</p>`,
    image: 'https://readdy.ai/api/search-image?query=PUBG%20esports%20global%20partnership%20announcement%20event%20with%20team%20logos%20displayed%20on%20large%20screen%2C%20professional%20gaming%20conference&width=800&height=500&seq=news-pubg-01&orientation=landscape',
    date: '2026.08.03',
    category: '行业动态',
    game: 'PUBG',
    views: 6300,
    slug: 'pubg-global-partner-program',
    author: '行业观察员',
    tags: ['PUBG', '全球合作', '电竞生态'],
  },
];

export function getArticleBySlug(slug: string): ArticleData | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getRelatedArticles(currentId: number, count: number = 3): ArticleData[] {
  return articles.filter((a) => a.id !== currentId).slice(0, count);
}